export const calculateFinancialTotals = (items = []) => {
  let totalCost = 0;
  let totalSell = 0;

  items.forEach((item) => {
    totalCost += item.quantity * (item.cost_price || 0);
    totalSell += item.quantity * (item.sell_price || 0);
  });

  const profit = totalSell - totalCost;
  const margin = totalCost > 0 ? ((profit / totalCost) * 100).toFixed(2) : 0;

  return { totalCost, totalSell, profit, margin };
};

export const calculateOrderProgress = (items = []) => {
  const totalOrdered = items.reduce((sum, item) => sum + item.quantity, 0);
  const totalFulfilled = items.reduce((sum, item) => sum + (item.quantity_fulfilled || 0), 0);
  const totalInvoiced = items.reduce((sum, item) => sum + (item.quantity_invoiced || 0), 0);

  const fulfillment = totalOrdered > 0 ? (totalFulfilled / totalOrdered) * 100 : 0;
  const invoicing = totalFulfilled > 0 ? (totalInvoiced / totalFulfilled) * 100 : 0;

  return {
    fulfillment: Math.round(fulfillment),
    invoicing: Math.round(invoicing),
    totalOrdered,
    totalFulfilled,
    totalInvoiced,
  };
};
